



















































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import utils from "@/services/utils";
import { getModule } from "vuex-module-decorators";
import AuthModule from "@/store/modules/Auth";

@Component
export default class LogBody extends Vue {
  AuthInstance = getModule(AuthModule, this.$store);

  @Prop() readonly data!: any;

  @Prop() readonly col!: number;

  @Prop() readonly fetchWinloseAgent!: Function;

  @Prop() readonly fetchResult!: Function;

  @Prop() readonly totalLog!: number;

  @Prop() readonly summaryLog!: number;

  @Prop() readonly paginationDetail!: object;

  utilsInstance = utils;

  isAdmin = ["SUPERADMIN", "ADMIN"].includes(this.AuthInstance.user.role);

  handleSub(username, role) {
    this.fetchWinloseAgent(username, role);
  }
}
